import styled from 'styled-components';

import { TRole } from '@/store/chat/types';

const BaseIcon = styled.span<{ disabled?: boolean }>`
  border-radius: 50%;
  padding: 0.7rem;
  background: var(--color-highlight-lighter);
  margin-left: 0.5rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: 1.3rem;
  position: absolute;
  top: 15px;
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  visibility: ${({ disabled }) => (disabled ? 'hidden' : 'visible')};
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;

  &:hover {
    opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
    visibility: ${({ disabled }) => (disabled ? 'hidden' : 'visible')};
  }
`;

export const EditIcon = styled(BaseIcon)`
  left: -80px;
`;

export const DeleteIcon = styled(BaseIcon)`
  left: -40px;
`;

export const HoverArea = styled.div<{ $ismobileortablet: boolean; role: TRole; $isAi?: boolean }>`
  position: relative;
  display: flex;
  justify-content: ${({ role }) => (role === 'human' ? 'flex-end' : 'flex-start')};
  ${({ $isAi }) => $isAi && 'width: 100%;'}

  ${EditIcon},
  ${DeleteIcon} {
    opacity: ${({ $ismobileortablet }) => ($ismobileortablet ? 1 : 0)};
    visibility: ${({ $ismobileortablet }) => ($ismobileortablet ? 'visible' : 'hidden')};
    transition:
      opacity 0.3s ease-in-out,
      visibility 0.3s ease-in-out;
  }

  &:hover ${EditIcon}, &:hover ${DeleteIcon} {
    opacity: 1;
    visibility: visible;
  }
`;

export const BubbleWrapper = styled.div<{ role: TRole }>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ role }) => (role === 'human' ? 'flex-end' : 'flex-start')} !important;
  align-items: ${({ role }) => (role === 'human' ? 'end' : 'start')} !important;
  margin: 1.8rem 0;
  padding-left: ${({ role }) => (role === 'human' ? '10rem' : 0)} !important;
  width: 100%;
  position: relative;
`;

export const Bubble = styled.div<{ role: TRole; $isediting: boolean }>`
  background: ${({ role, $isediting }) =>
    $isediting ? 'transparent' : role === 'human' ? 'var(--color-highlight-lighter)' : 'var(--gray-decent)'};
  color: var(--gray-darkest);
  padding: 1rem 2rem;
  margin-top: ${({ role }) => (role === 'human' ? '1rem' : 0)};
  word-wrap: break-word;
  border-radius: 6px;
  position: relative;
  min-width: min(25rem, 5%);

  @media (max-width: 64rem) {
    padding: 0.5rem 1.4rem;
  }
`;
